export default __webpack_public_path__ + "static/media/image-study-admin-m@3x.356a05ff.webp";